module.exports = __webpack_public_path__ + "img/e73fe15.jpg";